import React from 'react';
// import axios from '../actions/config'
import { Link, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux'
import routes from '../routes'
// import leftArrow from '../assets/icon_left_arrow.png'
import { goCloseNative, goBackPressed, } from '../actions/actions-factory'
import { NotAuthorize, ModalClose } from '../components'
// import winston from "winston";
// import { API_V1_1, TOKEN_STATIC } from '../actions/constants'

class DefaultLayout extends React.Component {
	state = {
		showNotif: false,
		confirmIsOpen: false,
		textHeader: '',
		type: '',
		textReason: '',
		tokenStatus: false,
	}

	componentDidMount() {
		// localStorage.clear();
		// const { auth, history, location: { pathname } } = this.props
		// var isMenuOpen = '';
		// document.title = "Ottopay - Register"
		// localStorage.clear();
		// this.created()
		
	}


	// goBack() {
	// 	const { location: { pathname }, goCloseNative } = this.props

	// 	switch (pathname) {
	// 		case "/":
	// 				goCloseNative()
	// 		break;
	// 		case "/term-condition":
	// 			this.props.history.push({pathname: "/"})
	// 		break;
	// 		case "/pin":
	// 			this.props.history.push({pathname: "/term-condition"})
	// 		break;
	// 		case "/opsi-otp":
	// 			this.props.history.push({pathname: "/pin"})
	// 		break;
	// 		case "/otp":
	// 			this.props.history.push({pathname: "/opsi-otp"})
	// 		break;
	// 		default:
	// 			this.props.history.go(-1);
	// 		break;
	// 	}
	// }

	render() {
		const { location: { pathname }, goCloseNative } = this.props
		const { 
			confirmIsOpen,
			// textHeader,
			// textReason,
			// type,
			// tokenStatus
		} = this.state

		// if (tokenStatus) {
		// 	return <NotAuthorize />
		// }

		return (
			<React.Fragment>
				<ModalClose
					confirmIsOpen={confirmIsOpen}
					confirmClose={() => this.setState({confirmIsOpen: false})}
					confirmCloseNative={() => goCloseNative()}
				/>

				<div className='auth'>
					{/* <div className=""> */}
						{/* <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light">
							<div className="col-12" style={{padding: '0'}}>
								<div className="row">
									<div className="col-3 align-self-center" onClick={() => this.goBack()}>
										{ pathname === '/' ? ''
										:
										<img src={leftArrow} style={{width: '1.2rem', height: '1.3rem', verticalAlign: 'text-top'}} />							
										}
									</div>
									<div className="col-6 text-center align-self-center" style={{fontSize: '1rem'}}>
										{ pathname === '/opsi-otp' ? 
											'Opsi Pengiriman OTP' :
											'Daftar Sekarang'
										}
									</div>
									<div className="col-3 btn-text-close text-primary align-self-center" onClick={() => this.setState({confirmIsOpen: true})}>
										Tutup
									</div>
								</div>
							</div>
						</nav>  */}

						{/* <div>  */}
						<Switch>
							{routes.map((route, idx) => {
								return route.component ? 
									(<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
										<route.component {...props} />
									)} />)
									: (null);
								},
							)}
						</Switch>
						{/* </div> */}
					{/* </div> */}
				</div>
			</React.Fragment>
		);
	};
};

export default connect(
	({auth}) => ({ auth }),
	{ goCloseNative, goBackPressed}
)(DefaultLayout);
